import { ChangeDetectionStrategy, Component, output } from '@angular/core';

export type AddBriefChoice = 'type' | 'upload' | 'doc' | 'help';

@Component({
  selector: 'cbss-add-brief',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './a-add-brief.html',
})
export class CreateBriefSelectSmartAddBrief {
  readonly chosen = output<AddBriefChoice>();

  readonly choices: {
    choice: AddBriefChoice;
    name: string;
    description: string;
  }[] = [
    {
      choice: 'type',
      name: 'Type it out',
      description: 'Just start typing in the box below. Rough notes are fine.',
    },
    {
      choice: 'upload',
      name: 'Upload a document',
      description: 'Drag a PDF, DOCX or TXT into the chat, or click the paperclip to browse.',
    },
    {
      choice: 'doc',
      name: 'Link a Google Doc',
      description: "Paste the share link in the box below. We'll check access.",
    },
    {
      choice: 'help',
      name: 'Get AI to help',
      description: "No brief yet? Answer a few quick questions and we'll write it.",
    },
  ];

  choose(choice: AddBriefChoice): void {
    this.chosen.emit(choice);
  }
}
